import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../providers/auth-provider";
import hasPermission from "../functions/has-permission";

export default function RequirePermission({ permission, children, fallback = "/" }) {
  const { user } = useAuth();

  if (!hasPermission(user, permission)) {
    return <Navigate to={fallback} replace />;
  }

  return children;
}
